module.exports = __webpack_public_path__ + "img/Icon__province_7.75ecf2e3.svg";